import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/HomePage/HomePage";
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authProvider";
import History from "../pages/History/History";
import RequestDetailPage from "../pages/RequestDetail/RequestDetailPage";

console.log('🟠 MAIN.JS - Loading');

const ProtectedComponent = ({ children }) => {
  const { instance } = useMsal();

  // Auto-redirect to Microsoft login when not authenticated
  useEffect(() => {
    const accounts = instance.getAllAccounts();
    if (accounts.length === 0) {
      instance.loginRedirect(loginRequest);
    }
  }, [instance]);

  return (
    <AuthenticatedTemplate>
      {children}
    </AuthenticatedTemplate>
  );
};


const Main = () => {
  return (
    <div>
      <main>
        <Routes>
        
          <Route path="/history" element={
            <ProtectedComponent>
              <History />
            </ProtectedComponent>
          } />

          <Route path="/history/:id" element={
            <ProtectedComponent>
              <RequestDetailPage />
            </ProtectedComponent>
          } />

          <Route path="/request" element={
            <ProtectedComponent>
              <Home />
            </ProtectedComponent>
          } />

          <Route path="/" element={<Navigate to="/request" replace={true} />} />
        </Routes>
      </main>
    </div>
  );
};

export default Main;
